import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import Home from "../components";
import { ApplicationState } from "../../../redux/ApplicationState";
import { getMasterServiceProvider, getMasterServiceProviderDefault } from "../../../actions/Master";
import { getReferralListByProviderId, getReferralSearchList } from "../../../actions/ReferralAction";
import { ReferralDetailsPayload, ReferralSearchPayload } from "../../../models/Referral";
import { GetReferralSearchListActionDispatchTypes } from "../../../constants/HomePage";
import { logoutPortalApp, postUserPageTrack } from "../../../actions/UserAction";
import { UserPageTrack } from "../../../models/User";

const mapStateToProps = ({
  masterServiceProviderDefaultState,
  loggedInUserState,
  referralListState,
  referralSearchState,
  samlResponseState,
  userLogoutState,
  refreshTokenResponseState
}: ApplicationState) => ({
  masterServiceProviderList: masterServiceProviderDefaultState.response,
  loggedInUser: loggedInUserState.response,
  referralList: referralListState.response,
  referralSearchList: referralSearchState.response,
  samlResponseState: samlResponseState.response,
  userLogoutState: userLogoutState.response,
  refreshTokenResponseState: refreshTokenResponseState.response
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getMasterServiceProviderDefault: () => {
      dispatch(getMasterServiceProviderDefault());
    },
    getReferralListByProviderId: (payload: ReferralDetailsPayload) => {
      dispatch(getReferralListByProviderId(payload))
    },
    getReferralSearchList: (payload: ReferralSearchPayload) => {
      dispatch(getReferralSearchList(payload));
    },
    resetReferralSearchList: () => {
      dispatch({
        type: GetReferralSearchListActionDispatchTypes.GET_REFERRAL_SEARCH_LIST_RESET,
      });
    }, 
    getMasterServiceProvider: () => {
      dispatch(getMasterServiceProvider());
    },
     postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
    logoutPortalApp: () => { 
      dispatch(logoutPortalApp());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
